// libraries
import { Typography } from '@interstate/components/Typography';

// types
import type { PurchaseHistoryCard } from '@makemydeal/dr-dash-types';

// components
import PurchaseHistoryCardUI from './PurchaseHistoryCardUI';

// styles
import { StyledCardList, StyledSectionHeader } from './PurchaseHistorySection.style';

export type PurchaseHistorySectionUIProps = {
    /** Always at least one record — an empty result is the section's `empty` state, not this one. */
    records: PurchaseHistoryCard[];
};

/**
 * The ready state: a counted header and one card per prior purchase.
 *
 * Records arrive already ordered most-recent-first from the selector; this component does not sort.
 */
export const PurchaseHistorySectionUI = ({ records }: PurchaseHistorySectionUIProps) => (
    <div data-testid="purchase-history-section">
        <StyledSectionHeader>
            <Typography tag="h3" variant="h6" color="sem.color.on-surface.default" data-testid="purchase-history-header">
                {`Purchase History (${records.length})`}
            </Typography>
        </StyledSectionHeader>
        <StyledCardList>
            {records.map((record, index) => (
                <PurchaseHistoryCardUI key={`${index}-${record.soldDate}`} record={record} index={index} />
            ))}
        </StyledCardList>
    </div>
);

export default PurchaseHistorySectionUI;
